/*
 * ShelfWorlds: keep product cards inside blog articles live.
 * Cards are written into article HTML with a "Shop this kit" or "See the kit" link to /products/<handle>.
 * The price and availability shown in the card are refreshed from the product's JSON, so a price change
 * or a sold-out kit never leaves an article out of date. If the request fails, the card stays as written.
 */
(function () {
  'use strict';

  const LINK_TEXT = /^(shop this kit|see the kit)$/i;
  const PRICE = /\$\d[\d,]*(?:\.\d{2})?/;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function findCards(root) {
    const cards = [];
    root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (!LINK_TEXT.test(link.textContent.trim())) return;
      const container = link.closest('div[style*="display:flex"], div[style*="display: flex"]');
      if (!container || !root.contains(container)) return;
      const match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      if (match) cards.push({ container, link, handle: match[1] });
    });
    return cards;
  }

  async function refresh(card, currency) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${card.handle}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    const product = await response.json();

    const priceLine = Array.from(card.container.querySelectorAll('p')).find((p) => PRICE.test(p.textContent));
    if (priceLine) {
      priceLine.innerHTML = priceLine.innerHTML.replace(PRICE, formatMoney(product.price, currency));
      if (!product.available) {
        priceLine.innerHTML = priceLine.innerHTML.replace(/Ships in [^<]*/i, 'Sold out for now');
      }
    }

    if (!product.available) {
      card.container.classList.add('sw-card-sold-out');
      card.link.textContent = 'See the kit';
      card.link.style.background = 'transparent';
      card.link.style.color = 'var(--sw-action)';
      card.link.style.border = '1px solid var(--sw-action)';
    }
  }

  function init() {
    const roots = document.querySelectorAll('.blog-post-content');
    if (!roots.length) return;
    const currency = window.Shopify?.currency?.active || 'USD';
    roots.forEach((root) => {
      findCards(root).forEach((card) => {
        refresh(card, currency).catch(() => {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
